// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export const allLabel = 'all';
export const memberModalAddTitle = 'Add Team Member';
export const memberModalEditTitle = 'Edit Team Member';
export const newMemberAdded = 'Member Added Successfully';
export const failedMemberAdded = 'Failed to add New Member';
export const memberUpdated = 'Member updared';
export const failedMemberUpdate = 'Member update failed';
